import {
  Country,
  getCountryByCountryCode,
  RedeemGiftPayload,
  Registration,
  UserType,
} from "@ecologi/shared";
import { fetchFromAPI } from "./fetch-from-api";

export const getGiftingCouponCode = async (
  _,
  couponCode: string
): Promise<{ country: Country }> =>
  fetchFromAPI<{ country: Country }>(`/gifting/${couponCode}`, {
    passthrough: "api",
  });

export const redeemGift = async (
  data: RedeemGiftPayload
): Promise<{ user: UserType; planId: string }> => {
  const body: Registration.Request = {
    type: "gifting",
    user: {
      password: data.password,
      groupName: data.groupName,
      referralSource: undefined,
      referrerUserId: undefined,
      affiliateClickId: undefined,
      isMarketingAccepted: undefined,
      parent: undefined,
      campaignSource: undefined,
    },
    customer: {
      lastName: data.lastName,
      firstName: data.firstName,
      postCode: undefined,
      emailAddress: data.email,
      country: getCountryByCountryCode(data.country),
      location: data.country,
    },
    promoCode: data.couponCode,
  };

  return fetchFromAPI(`/register`, {
    body: JSON.stringify(body),
    method: "POST",
    passthrough: "edge",
  });
};
